import React, { Component } from "react";
import _ from "lodash";
import { setIn, removeLast, addLast } from "timm";

const NODE_TYPE_COLLECTION = "NODE_TYPE_COLLECTION";
const NODE_TYPE_ARRAY = "NODE_TYPE_ARRAY";
const NODE_TYPE_INPUT = "NODE_TYPE_INPUT";

function typeOfNode(node, types) {
  if (Array.isArray(node)) {
    return NODE_TYPE_ARRAY;
  }

  const typeProperties = types[node];
  if (typeProperties._isCollection) {
    return NODE_TYPE_COLLECTION;
  }

  return NODE_TYPE_INPUT;
}

function buildValueTree(type, types, data) {
  function valueForInput(type, data) {
    if (data) {
      const { toState } = types[type];
      return toState ? toState(data) : data;
    } else {
      return types[type].defaultState();
    }
  }

  function valueForCollection(type, data) {
    const parentProps = types[type];

    const propertiesForType = Object.keys(parentProps).filter(
      (prop) =>
        prop !== "_isCollection" &&
        !prop.startsWith("@") &&
        !prop.startsWith("+")
    );

    return propertiesForType.reduce((ack, propName) => {
      const childType = types[type][propName];
      if (data) {
        const childData = data[propName];
        ack[propName] = valueForNode(childType, childData);
      } else {
        ack[propName] = valueForNode(childType);
      }
      return ack;
    }, {});
  }

  function valueForArray(type, data) {
    if (data) {
      return data.map((d) => valueForNode(type, d));
    } else {
      return [valueForNode(type)];
    }
  }

  function valueForNode(type, data) {
    const nodeType = typeOfNode(type, types);

    if (nodeType === NODE_TYPE_INPUT) {
      return valueForInput(type, data);
    }

    if (nodeType === NODE_TYPE_COLLECTION) {
      return valueForCollection(type, data);
    }

    if (nodeType === NODE_TYPE_ARRAY) {
      return valueForArray(type[0], data);
    }
  }

  return valueForNode(type, data);
}

export default class FormTree extends Component {
  collect() {
    return this.ref.collect();
  }

  constructor(props) {
    super(props);

    const { type, types } = props;
    const values = buildValueTree(type, types);
    this.state = {
      values,
      unibetData: {},
    };
  }

  updateUnibetJson = (value) => {
    this.setState({ unibetData: value });
  };

  updateState = (path, value) => {
    const { values } = this.state;
    const newValues = setIn(values, path, value);
    this.setState({ values: newValues });
  };

  clear() {
    this.setValue();
  }

  setValue(data) {
    const { type, types } = this.props;

    const values = buildValueTree(type, types, data);

    this.setState({ values });
  }

  render() {
    const { type, types, arrayLayout, collectionLayout } = this.props;
    const { values, unibetData } = this.state;

    return (
      <InputNode
        values={values}
        path={[]}
        updateValues={this.updateState}
        updateUnibetState={this.updateUnibetJson}
        name={type}
        type={type}
        types={types}
        arrayLayout={arrayLayout}
        collectionLayout={collectionLayout}
        ref={(r) => (this.ref = r)}
        unibetData={unibetData}
      />
    );
  }
}

class InputNode extends Component {
  collect() {
    return this.input.collect();
  }

  render() {
    const {
      values,
      path,
      updateValues,
      type,
      name,
      types,
      getGame,
      arrayLayout,
      collectionLayout,
      updateUnibetState,
      unibetData,
      test,
    } = this.props;
    const basicProps = {
      values,
      path,
      updateValues,
      updateUnibetState,
      name,
      getGame,
      key: name,
      ref: (r) => (this.input = r),
      types,
      arrayLayout,
      collectionLayout,
      buildValueTree: buildValueTree,
      addLast: addLast,
      unibetData,
      test,
    };

    if (Array.isArray(type)) {
      return React.createElement(InputArray, {
        ...basicProps,
        type: type[0],
      });
    }
    const typeProperties = types[type];
    if (typeProperties._isCollection) {
      const propsArr = Object.keys(typeProperties)
        .map((key) => [key, typeProperties[key]])
        .filter(([k, _]) => k !== "_isCollection");

      const inputProps = propsArr.filter(
        ([key, _]) => !key.startsWith("@") && !key.startsWith("+")
      );
      const typeProps = propsArr.filter(([key, _]) => key.startsWith("@"));
      const staticProps = propsArr
        .filter(([key, _]) => key.startsWith("+"))
        .map(([key, value]) => [key.slice(1), value]);
      const fixedProps = [...typeProps, ...staticProps];

      return React.createElement(InputCollection, {
        ...basicProps,
        fields: inputProps,
        fixedProps,
      });
    }

    return React.createElement(typeProperties, basicProps);
  }
}

class InputArray extends Component {
  constructor(props) {
    super(props);
    this.inputs = [];
  }

  collect() {
    const { values: inputs } = this.props;
    const rawValues = inputs.map((_, i) => this.inputs[i].collect());
    const values = rawValues.filter((v) => v !== null);
    for (var i = 0; i < values.length; i++) {
      values[i].game = i + 1;
    }
    if (values.length > 0) {
      return values;
    }
    return null;
  }

  getGame(pathIndex) {
    const { values, path, type, types, updateValues } = this.props;
    // console.log(values);
    return values[pathIndex];
  }

  addInput() {
    const { values, path, type, types, updateValues } = this.props;
    const value = buildValueTree(type, types);
    const newData = addLast(values, value);
    updateValues(path, newData);
  }

  removeInput() {
    const { values, path, updateValues } = this.props;
    const newData = removeLast(values);
    updateValues(path, newData);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { values } = nextProps;
    const { values: oldValues } = this.props;
    return !_.isEqual(values, oldValues);
  }

  render() {
    const {
      updateValues,
      values,
      path,
      name,
      type,
      types,
      arrayLayout,
      collectionLayout,
      updateUnibetState,
      unibetData,
    } = this.props;

    const children = values.map((_, i) => {
      const childValues = values[i];
      // console.log("child--Values===>", values[i]);
      return (
        <>
          <div>Game {i + 1}</div>
          <InputNode
            updateValues={updateValues}
            values={childValues}
            path={[...path, i]}
            key={i}
            name={""}
            type={type}
            types={types}
            ref={(r) => (this.inputs[i] = r)}
            arrayLayout={arrayLayout}
            collectionLayout={collectionLayout}
            getGame={() => this.getGame(i)}
            updateUnibetState={updateUnibetState}
            unibetData={unibetData}
          />
        </>
      );
    });

    return React.createElement(arrayLayout, {
      name,
      children,
      onAdd: () => this.addInput(),
      onRemove: () => this.removeInput(),
    });
  }
}

class InputCollection extends Component {
  constructor(props) {
    super(props);

    this.inputs = {};
  }

  collect() {
    const { fields, fixedProps } = this.props;
    const keys = fields.map((f) => f[0]);

    const inputValues = keys.reduce((ack, k) => {
      const input = this.inputs[k];
      if (input) {
        const value = input.collect();
        if (value) {
          ack[k] = value;
        }
      }
      return ack;
    }, {});

    if (Object.keys(inputValues).length === 0) {
      return null;
    }

    const fixedPropsObj = fixedProps.reduce((obj, [k, v]) => {
      obj[k] = v;
      return obj;
    }, {});

    return {
      ...fixedPropsObj,
      ...inputValues,
    };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { values } = nextProps;
    const { values: oldValues } = this.props;

    return !_.isEqual(values, oldValues);
  }

  render() {
    const {
      updateValues,
      values,
      path,
      fields,
      types,
      arrayLayout,
      collectionLayout,
      name,
      getGame,
      updateUnibetState,
      unibetData,
    } = this.props;

    const children = fields.map(([key, type]) => {
      const childValues = values[key];
      if (values["template"] !== "Unibet - Games" && key === "template_alias") {
        return null;
      } else {
        return (
          <InputNode
            updateValues={updateValues}
            path={[...path, key]}
            values={childValues}
            key={key}
            name={key}
            getGame={getGame}
            type={type}
            types={types}
            arrayLayout={arrayLayout}
            collectionLayout={collectionLayout}
            ref={(r) => (this.inputs[key] = r)}
            buildValueTree={buildValueTree}
            addLast={addLast}
            updateUnibetState={updateUnibetState}
            unibetData={unibetData}
          />
        );
      }
    });
    if (children.length === 1) {
      return children[0];
    }
    return React.createElement(collectionLayout, { name, children });
  }
}
